<template>
  <div>
    <section class="blockElement banner pb-0">
      <div class="container" align="center">
        <div class="m-0 banner_text text-center">
          <h1 class="m-0"><span>Downloads</span> & Forms</h1>
        </div>
      </div>
    </section>
    <section class="blockElement pTag wtx important_forms pt-5">
      <div class="container" align="center">
        <div class="head-title text-center">
          <h2><span>Important </span> Forms</h2>
          <p>NSE, BSE, MCX, NCDEX Forms</p>
        </div>

        <div
          class="downloadDocument d-flex align-items-center justify-content-center"
        >
          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="CDSL Individual" title="CDSL Individual"
              />
            </span>
            <h4>CDSL Individual <small>&nbsp;</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath +
                  downloadFolderPath +
                  'Finvasia_CDSL_EKYC_Indv.pdf'
                "
                target="_blank"
                >Download</a
              >
            </div>
          </div>
          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="Client Guidance" title="Client Guidance"
              />
            </span>
            <h4>Client Guidance <small>For DEMAT</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath +
                  downloadFolderPath +
                  'Finvasia_Client_Guidance_DEMAT.PDF'
                "
                target="_blank"
                >Download</a
              >
            </div>
          </div>

          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="MCX & NCDEX" title="MCX & NCDEX"
              />
            </span>
            <h4>Client Guidance <small>For MCX & NCDEX</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath +
                  downloadFolderPath +
                  'Finvasia_Client_Guidance_MCX_NCDEX.PDF'
                "
                target="_blank"
                >Download
              </a>
            </div>
          </div>

          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="NSE & BSE" title="NSE & BSE"
              />
            </span>
            <h4>Client Guidance <small>For NSE & BSE</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath +
                  downloadFolderPath +
                  'Finvasia_Client_Guidance_NSE_BSE.pdf'
                "
                target="_blank"
                >Download</a
              >
            </div>
          </div>

          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="Equity DP Individual" title="Equity DP Individual"
              />
            </span>
            <h4>Equity DP Individual <small>&nbsp;</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath +
                  downloadFolderPath +
                  'finvasia_equity_dp_individual.pdf'
                "
                target="_blank"
                >Download
              </a>
            </div>
          </div>
          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="MCX eKYC Sept 2016" title="MCX eKYC Sept 2016"
              />
            </span>
            <h4>MCX eKYC<small>&nbsp;</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath + downloadFolderPath + 'MCX_eKYC_Sept_2016.pdf'
                "
                target="_blank"
                >Download
              </a>
            </div>
          </div>
          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="NSE Form" title="NSE Form"
              />
            </span>
            <h4>NSE Form<small>&nbsp;</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="appBasePath + downloadFolderPath + 'nsekyc1.pdf'"
                target="_blank"
                >Download
              </a>
            </div>
          </div>
          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="DDPI" title="DDPI"
              />
            </span>
            <h4>DDPI<small>&nbsp;</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath + downloadFolderPath + 'ddpi_form.pdf'
                "
                target="_blank"
                >Download
              </a>
            </div>
          </div>
          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="MCX & NCDEX" title="MCX & NCDEX"
              />
            </span>
            <h4>Non-Individual<small>For MCX & NCDEX</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath + downloadFolderPath + 'Non Indv. MCX, NCDEX.pdf'
                "
                target="_blank"
                >Download
              </a>
            </div>
          </div>
          <div class="build-section">
            <span>
              <img
                class="inBG img-fluid"
                src="../../../../static/website/images/pdf.svg"
                width="32" height="40" alt="NSE & BSE" title="NSE & BSE"
              />
            </span>
            <h4>Non-Individual<small>For NSE & BSE</small></h4>
            <div class="customBtn-bt d-inline-block">
              <a
                class="fin_btn darkBG"
                :href="
                  appBasePath + downloadFolderPath + 'Non Indv. NSE, BSE KYC.pdf'
                "
                target="_blank"
                >Download
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="blockElement pTag downloadsoftware wtx important_forms pt-0"
    >
      <div class="container" align="center">
        <div class="head-title text-center">
          <h2><span>Trading </span> Platforms</h2>
        </div>
        <div class="row justify-content-center">
          <!-- <div class="col-12 col-md-3">
                        <div class="build-section">
                            <span>
                              <img class="inBG" src="../../../../static/website/images/scalpert.svg" alt="" />
                            </span>
                            <h4>SCALPERT</h4> 
                            <div class="customBtn-bt d-inline-block">
                                <a class="fin_btn darkBG" href="https://play.google.com/store/apps/details?id=com.mt.platform.fa&hl=en" target="_blank">Trade now</a>
                            </div>
                        </div>
                    </div> -->
          <div class="col-12 col-md-3">
            <div class="build-section">
              <span>
                <img
                  class="inBG"
                  src="../../../../static/website/images/shoonya_icon_svg.svg"
                  width="40" height="40" alt="Shoonya" title="Shoonya"
                />
              </span>
              <h4>Shoonya</h4>
              <div
                class="customBtn-bt d-flex align-items-center justify-content-center"
              >
                <a
                  class="darkBG"
                  href="https://trade.shoonya.com/"
                  target="_blank"
                  ><img
                    class="inBG img-fluid"
                    src="../../../../static/website/images/ico_web.svg"
                    width="22" height="22" alt="website" title="website"
                /></a>
                <a
                  class="darkBG"
                  :href="appBasePath + downloadExePath + 'SHOONYA.exe'"
                  target="_blank"
                  ><img
                    class="inBG img-fluid" 
                    src="../../../../static/website/images/ico_window.svg"
                    width="22" height="22" alt="windows" title="windows"
                /></a>
                <a
                  class="darkBG"
                  href="https://play.google.com/store/apps/details?id=com.rs.shoonya&hl=en_IN&gl=US"
                  target="_blank"
                  ><img
                    class="inBG img-fluid"
                    src="../../../../static/website/images/ico_android.svg"
                    width="22" height="22" alt="android" title="android"
                /></a>
                <a
                  class="darkBG"
                  href="https://apps.apple.com/us/app/shoonya/id1539034076"
                  target="_blank"
                  ><img
                    class="inBG img-fluid"
                    src="../../../../static/website/images/ico_apple.svg"
                    width="19" height="22" alt="apple" title="apple"
                /></a>
              </div>
            </div>
          </div>

          <!-- <div class="col-12 col-md-3">
                        <div class="build-section">
                            <span>
                              <img class="inBG" src="../../../../static/website/images/shoonya_icon_svg.svg" alt="" />
                            </span>
                            <h4>Shoonya Beta</h4> 
                             <div class="customBtn-bt d-flex align-items-center justify-content-center">
                                <a class="darkBG" href="https://shoonyatrade.finvasia.com/#/" target="_blank"><img class="inBG" src="../../../../static/website/images/ico_web.svg" alt="" /></a>
                                <a class="darkBG" :href="appBasePath+downloadExePath+'SHOONYA_beta.exe'" target="_blank"><img class="inBG" src="../../../../static/website/images/ico_window.svg" alt="" /></a>
                                <a class="darkBG" href="https://play.google.com/store/apps/details?id=com.finvasia.shoonyatrade" target="_blank"><img class="inBG" src="../../../../static/website/images/ico_android.svg" alt="" /></a>
                            </div>
                        </div>
                    </div> -->
          <!-- <div class="col-12 col-md-3">
                        <div class="build-section">
                            <span>
                              <img class="inBG" src="../../../../static/website/images/puzzle.svg" alt="" />
                            </span>
                            <h4>NEST</h4>
                            <div class="customBtn-bt d-inline-block">
                                <a class="fin_btn darkBG" :href="appBasePath+downloadFolderPath+'NestTrader_3.16.0.7_finvasia_Launcher_Investor_x64.exe'" target="_blank">Download</a>
                            </div> 
                        </div>
                    </div> -->
          <!-- <div class="col-12 col-md-3">
                        <div class="build-section">
                            <span>
                              <img class="inBG" src="../../../../static/website/images/fox.webp" alt="" />
                            </span>
                            <h4>FOXTRADER</h4>
                            <div class="customBtn-bt d-inline-block">
                                <a class="darkBG" href="http://www.reliable.co.in/RW.HomeV1.FoxChargesV2Yearly.aspx?Product=foxtrader" target="_blank"><img class="inBG" src="../../../../static/website/images/ico_window.svg" alt="" /></a> 
                            </div> 
                        </div>
                    </div> -->
        </div>
      </div>
    </section>
    <section
      class="blockElement pTag downloadsoftware wtx important_forms pt-0"
    >
      <div class="container" align="center">
        <div class="head-title text-center">
          <h2>Tools</h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-3">
            <div class="build-section">
              <span>
                <img
                  class="inBG"
                  src="../../../../static/website/images/getSupport.svg"
                  width="33" height="40" alt="Remote Support" title="Remote Support"
                />
              </span>
              <h4>Remote Support</h4>
              <div
                class="customBtn-bt d-flex align-items-center justify-content-center"
              >
                <!-- <a class="darkBG" href="https://shoonya.finvasia.com/" target="_blank"><img class="inBG" src="../../../../static/website/images/ico_web.svg" alt="" /></a> -->
                <a
                  title="Window"
                  class="darkBG"
                  href="https://sos.splashtop.com/69A0562A4918897FC8A082A3499CB3AA/75XASHT4TJAT/d3437b6771ab8ae6cf10e18f05d71ae6/3.5.4.0/SplashtopSOS_Win_v3.5.4.0_75XASHT4TJAT.exe"
                  target="_blank" 
                  ><img
                    class="inBG img-fluid"
                    src="../../../../static/website/images/window.svg"
                    width="22" height="22" alt="window" title="window"
                /></a>
                <a
                  title="Mac"
                  class="darkBG"
                  href="https://sos.splashtop.com/69A0562A4918897FC8A082A3499CB3AA/75XASHT4TJAT/d3437b6771ab8ae6cf10e18f05d71ae6/3.5.4.0/SplashtopSOS_Mac_v3.5.4.0_75XASHT4TJAT.dmg"
                  target="_blank"
                  ><img
                    class="inBG img-fluid"
                    src="../../../../static/website/images/macbook.svg"
                    width="27" height="22" alt="macbook" title="macbook"
                /></a>
                <a
                  title="Andriod"
                  class="darkBG "
                  href="https://play.google.com/store/apps/details?id=com.splashtop.sos"
                  target="_blank"
                  ><img
                    class="inBG img-fluid"
                    src="../../../../static/website/images/ico_android.svg"
                    width="22" height="22" alt="android" title="android"
                /></a>
                <a
                  title="App Store"
                  class="darkBG"
                  href="https://apps.apple.com/in/app/splashtop-sos/id1230853703"
                  target="_blank"
                  ><img
                    class="inBG img-fluid"
                    src="../../../../static/website/images/ico_apple.svg"
                    width="19" height="22" alt="apple" title="apple"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="blockElement custmAcc pTag wtx customAccordion pt-0">
            <div class="container" align="center">
                <div class="head-title text-center">
                    <h2><span>Fund </span> Transfer Bank Details</h2>
                    <p>NSE/BSE/MCX/NCDEX</p>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8" id="accordionExample">   
                        <div id="accordionExample" class="accordion downloadpageaccordion">
                            <section class="faq">
                                <div  class="faq-wrapper">
                                    <div class="accordion">
                                        <div class="accordion__item">
                                            <div class="accordion__title d-flex align-items-center justify-content-between" :class="{active: showIMPS}" v-on:click="showIMPS = !showIMPS">
                                                <p class="accordion__title-text">RTGS / NEFT / IMPS / FT</p>
                                                <plus-icon class="plusicon"></plus-icon>
                                            </div> 
                                            <div class="show" v-show="showIMPS">
                                                <p class="accordion__value">
                                                    <div class="card-body cp-pad">
                                                        <ul align="left">
                                                            <li>
                                                                <strong>Virtual Bank Account Number</strong>
                                                            </li>
                                                            <li>
                                                                Each client has their own separate virtual bank account, where first 6 alphabets will be FINVAS followed by your client code. So, your virtual account number shall be "FINVAS". You can also find these details in PRISM under "ADD
                                                                FUND".
                                                            </li>
                                                            <li>
                                                                <div class="bnkinput">
                                                                    For example: enter your client code (UCC) here
                                                                    <input type="text" class="form-control" v-model="clientcode" />
                                                                </div>
                                                            </li>
                                                            <li>below shall be your virtual bank account information</li>
                                                            <li>
                                                                Bank Account Number :
                                                                <strong>FINVAS{{clientcode}}</strong>
                                                            </li>
                                                            <li><strong>Beneficiary Name:</strong> FINVASIA SECURITIES PVT LTD</li>
                                                            <li><strong>Bank Name:</strong> HDFC BANK LTD</li>
                                                            <li><strong>IFSC Code:</strong> HDFC0000873</li>
                                                            <li><strong>Branch Name:</strong> Industrial Area, Chandigarh</li>
                                                        </ul>
                                                    </div> 
                                                </p>
                                            </div>
                                        </div>
                                        <div class="accordion__item">
                                            <div class="accordion__title d-flex align-items-center justify-content-between"  v-on:click="showCH=!showCH" :class="{active: showCH}" >
                                                <p class="accordion__title-text">Cheque Deposit Only</p>
                                                <plus-icon   class="plusicon"></plus-icon>
                                            </div>
                                        </div>
                                        <div  v-show="showCH">
                                            <p data-v-dd43507e="" class="accordion__value"><div class="card-body cp-pad"><ul align="left"><li><strong>FINVASIA SECURITIES PVT LTD</strong> </li><li><strong>A/C #:</strong> 08730340000255 </li><li><strong>Bank Name:</strong> HDFC BANK </li><li><strong>Bank Address:</strong> PLOTNO.28, PHASE 1, INDUSTRIAL AREA, CHANDIGARH</li></ul></div></p>
                                        </div> 
                                    </div>
                                </div>
                            </section>
                        </div> 
                    </div>
                </div>
            </div>
            <app-seo></app-seo>
        </section> -->
  </div>
</template>
<script>
import SEO from "../shared/SEO";
import VueFaqAccordion from "vue-faq-accordion";
import { PlusIcon } from "vue-feather-icons";
export default {
  components: {
    VueFaqAccordion,
    appSeo: SEO,
    PlusIcon,
  },

  data() {
    return {
      appBasePath: "https://shoonya.com",
      downloadFolderPath: "/downloads/pdfs/",
      downloadExePath: "/downloads/",
      scalpertDownloadPath: process.env.SCLAPERT_DOWNLOAD,
      nestDownloadPath: process.env.NEST_DOWNLOAD,
      foxtraderDownloadPath: process.env.FOXTRADER_DOWNLOAD,
      clientcode: "",
      showCH: false,
      showIMPS: false,
      myItems: [
        {
          title: "RTGS / NEFT / IMPS / FT",
          value:
            '<div class="card-body cp-pad"><ul align="left"><li><strong>Virtual Bank Account Number</strong> </li><li>Each client has their own separate virtual bank account, where first 6 alphabets will be FINVAS followed by your client code. So, your virtual account number shall be "FINVAS". You can also find these details in PRISM under "ADD FUND".</li><li><div class="bnkinput">For example: enter your client code (UCC) here  <input type="text" class="form-control" v-model="clientcode" onkeyup="myFunction()" id="cc"/></div></li><li>below shall be your virtual bank account information </li><li>Bank Account Number : <strong>FINVAS' +
            this.clientcode +
            "</strong></li><li></li><li><strong>Beneficiary Name:</strong> Shoonya SECURITIES PVT LTD</li><li><strong>Bank Name:</strong> HDFC BANK LTD</li><li><strong>IFSC Code:</strong> HDFC0000873</li><li><strong>Branch Name:</strong> Industrial Area, Chandigarh</li></ul></div>",
        },
        {
          title: "Cheque Deposit Only",
          value:
            '<div class="card-body cp-pad"><ul align="left"><li><strong>Shoonya SECURITIES PVT LTD</strong> </li><li><strong>A/C #:</strong> 08730340000255 </li><li><strong>Bank Name:</strong> HDFC BANK </li><li><strong>Bank Address:</strong> PLOTNO.28, PHASE 1, INDUSTRIAL AREA, CHANDIGARH</li></ul></div>',
        },
      ],
    };
  },
  methods: {
    showIMPS: function () {
      this.isActive = !this.isActive;
      // some code to filter users
    },
  },
  mounted() {
    window.scroll(0, 0);
    const _that = this;
    function myFunction() {
      var x = document.getElementById("cc");
      x.value = x.value.toUpperCase();
      _that.clientcode = x.value;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/shared/download.vue